module.exports = __webpack_public_path__ + "media/images/bus/no_info-9dd4f5680c80736b8954d5ba6d55d91b.svg";